// extracted by mini-css-extract-plugin
export default {"container":"theme_container__ZMpzu","image":"theme_image__VHUIE","title":"theme_title__KLTUV","description":"theme_description__sIXsy"};